// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__SccOQ","user_info":"Profile_user_info__Dgywo"};